import type { UniclientComponent } from '../component';
import type { GridResponsiveColumns } from '../utils';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

interface InputCardItem<TComponentAttributes extends string = string> {
  readonly title: string;
  readonly component: UniclientComponent<TComponentAttributes> | UniclientComponent<TComponentAttributes>[];
}

export interface InputCardsProps extends UniclientBaseComponentProps {
  readonly columns?: GridResponsiveColumns;
  readonly items: InputCardItem[];
}

export type WizardInputCardsProps = InputCardsProps & UniclientWizardComponentBase<'input_cards'>;

export function inputCards(props: InputCardsProps): WizardInputCardsProps {
  return {
    ...props,
    type: 'input_cards',
  };
}
